// extracted by mini-css-extract-plugin
export default {"Sample":"feeds_Sample__0Q5WO","selectedElements":"feeds_selectedElements__gi09W","SampleButtons":"feeds_SampleButtons__qJUIy"};